import ReplayIcon from '@mui/icons-material/Replay';
import AutorenewIcon from '@mui/icons-material/Autorenew'; // Alternative pour refresh
import { StatsCard } from './StatsCard'; // ajuste le chemin selon ton arborescence
import { getQueueStatus } from '../../../services/admin/cashManagement/cashManagement';
import { useEffect, useState } from 'react';
import { useAuth } from '../../../context/AuthContext/AuthContext';
import { toast } from 'react-toastify';

export default function QueueStatusWidget({
  onRefetchMount,
}: {
  onRefetchMount?: (cb: () => void) => void;
}) {
  const { tokens } = useAuth();
  const [status, setStatus] = useState<{ remainingCount: number; remainingAmount: string }>({
    remainingCount: 0,
    remainingAmount: '0'
  });
  const [loading, setLoading] = useState(false);

  const fetchStatus = async () => {
    if (!tokens?.accessToken) return;
    setLoading(true);
    try {
      const data = await getQueueStatus(tokens.accessToken);
      setStatus(data);
    } catch {
      toast.error("Impossible de charger le statut de la file.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();
    const iv = setInterval(fetchStatus, 30_000);
    return () => clearInterval(iv);
  }, [tokens]);

  // 🔁 Donne accès à fetchStatus au parent
  useEffect(() => {
    if (onRefetchMount) onRefetchMount(fetchStatus);
  }, [onRefetchMount]);

  return (
    <StatsCard
      title="Transactions en attente"
      label="Requêtes"
      value={status.remainingCount}
      currency={undefined}
      secondaryLabel="Montant total"
      secondaryValue={status.remainingAmount}
      secondaryCurrency="€"
      icon={<ReplayIcon />}
      tooltip="Statut des retraits en file d’attente"
    />
  );
}
